import PropTypes from 'prop-types';
var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
export default refType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/utils/esm/refType.js
// module id = 1490
// module chunks = 1